<template>
  <div class="event-dates">
    <b-modal hide-footer :id="`modal-center-${event.activityId}`" centered title="Selecciona una fecha del calendario">
      <div class="d-flex" style="flex-direction: column; align-items: center">
        <div v-if="selectedDate" class="card-header mb-2">
          {{ dateFriend(selectedDate.date) }}
        </div>
        <b-calendar
          hide-header
          v-model="calendarSelectedDate"
          width="300px"
          :date-info-fn="(ymd, date) => dateClass(ymd, date, item)"
          :date-disabled-fn="dateDisabled"
          locale="es"
        >
        </b-calendar>
        <div class="mt-4">
          <b-button
            @click="
              updateEventSelected({date:selectedDate})
              $bvModal.hide(`modal-center-${event.activityId}`);
            "
            variant="primary"
            >Aplicar</b-button
          >
        </div>
      </div>
    </b-modal>

    <diV class="event-dates__body">
      <div class="event-dates__dates">
        <div>
          <p class="body__step">
            <span class="indicator">1</span>
            Seleccionar fecha
          </p>
          <div
            v-if="showCalendar"
            @click="$bvModal.show(`modal-center-${event.activityId}`)"
            class="date-inp"
            style="cursor: pointer"
          >
            <span v-if="eventSelectedDate" style="font-weight: 700">{{ dateFriend(eventSelectedDate.date) }}</span>
            <span v-else style="color: #031425">Seleccionar fecha en el calendario</span>
          </div>
          <div v-else class="d-flex" style="gap: 1rem; flex-wrap: wrap;">
            <div
              v-for="(date, i) in formattedDates"
              :key="i"
              @click="updateEventSelected({date})"
              :class="(eventSelectedDate && eventSelectedDate.day) === date.day ? 'date-card--active' : ''"
              class="date-card"
              style=""
            >
              <div class="date-card__right" style="">
                <p class="month m-0" style="">{{ date.month }}</p>
                <p class="m-0">{{ date.year }}</p>
              </div>
              <span>{{ date.day }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="eventSelectedDate" class="event-dates__schedules">
        <p class="body__step mt-4">
          <span class="indicator">2</span>
          Seleccionar un horario
        </p>
        <div class="hours__tags px-3">
          <div
            v-for="(hourI, hourIdx) in eventSelectedDate.hours"
            :key="hourIdx"
            @click="getListTicketTypes(hourI)"
            :class="hour && hourI.dateHourId === hour.dateHourId ? 'hour--active' : ''"
            class="hour"
          >
            {{ formatHours(hourI) }}
          </div>
        </div>
      </div>
      <p v-if="ticketTypeError" style="color: red" class="mt-4 text-center">{{ ticketTypeError }}</p>
      <div v-if="eventSelectedDate && hour" class="event-dates__cart">
        <p class="body__step mt-4">
          <span class="indicator">3</span>
          Añadir cantidad y agregar al carrito
        </p>
        <div class="card-body p-3">
          <ul class="list-group">
            <li v-for="(type, index) in hour.types" :key="index" class="list-group-item">
              <div class="row align-items-center justify-content-between">
                <div class="flexi">
                  <div class="flexi-name">
                    <span>
                      <span>{{ type.name }} </span>
                      <div v-if="type.type === 'combo'">
                        Por unidad: <b>{{ getCurrencySymbol }} {{ Number(type.priceStock).toFixed(3) }}</b>
                      </div>
                    </span>
                    <b>{{ getCurrencySymbol }} {{ Number(type.price).toFixed(3) }} </b>
                  </div>
                  <b>- Disponibles({{ type.availableStock }})</b>
                </div>
                <template v-if="type.soldOutGroup === false
                  && type.availableStock >= type.minQuantityPerOrder">
                  <div
                    v-b-tooltip.hover="{ variant: 'danger' }"
                    :title="addDisabled ? 'Solo puedes comprar en un evento a la vez' : ''"
                    class="col-12 col-md-5 d-flex justify-content-end"
                    v-if="type.saleStatus.soldOut === false"
                  >
                    <div v-if="type.type === 'venue'" class="mr-3">
                      <button
                        @click="$emit('initSvgModal', type)"
                        :disabled="addDisabled"
                        class="btn btn-primary px-2"
                        type="button"
                      >
                        Ver Asientos
                      </button>
                    </div>
                    <select v-else v-model="type.value" :disabled="addDisabled" class="form-control mr-3">
                      <option v-for="(i, key) in quantityOptions(type)" :value="i" :key="key">
                        {{ formatTicketLabel(i, type) }}
                      </option>
                    </select>
                    <div>
                      <button
                        type="button"
                        @click="addToCart(type)"
                        class="btn btn-danger btn-block"
                        :disabled="!type.value || type.availableStock < 1 || addDisabled"
                      >
                        Añadir
                      </button>
                    </div>
                  </div>
                  <div v-else>
                    <b>Agotado</b>
                  </div>
                </template>
                <div v-else-if="(type.availableStock < type.minQuantityPerOrder) && type.availableStock > 0">
                  <b>
                    Esta entrada no puedes comprarla porque el mínimo de entradas requeridas es
                    {{(type.minQuantityPerOrder)}}, y actualmente solo hay
                    {{(type.availableStock)}} disponibles en stock.
                  </b>
                </div>
                <div v-else>
                  <b>Agotado</b>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </diV>
  </div>
</template>

<script>
import api from '../api';
import { getSafe } from '../utils/helpers';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    dates: {
      type: Array,
      default: () => ([]),
    },
    eventSelected: {
      type: Object,
      default: () => ({ date: null, hour: null })
    },
  },
  data() {
    return {
      showHourList: null,
      calendarSelectedDate: null,
      ticketTypeError: false
    };
  },
  computed: {
    eventSelectedDate() {
      return this.eventSelected.date;
    },
    hour() {
      return this.eventSelected.hour;
    },
    event() {
      return this.item;
    },
    listDates() {
      return this.dates;
    },
    showCalendar() {
      return this.event.flagEventRepeat && this.listDates.length >= 4;
    },
    formattedDates() {
      const formatTwo = (n) => (n > 9 ? `${n}` : `0${n}`);
      const weekday = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Dic'];
      return this.listDates.map((d) => {
        const dateFormat = new Date(d.date.split('-'));
        return {
          ...d,
          month: months[dateFormat.getMonth()],
          year: dateFormat.getFullYear(),
          day: `${weekday[dateFormat.getDay()]} ${formatTwo(dateFormat.getDate())}`,
        };
      });
    },
    selectedDate() {
      return this.listDates.find((date) => date.date === this.calendarSelectedDate);
    },
    // para limitar la compra de entraas a un solo evento
    cartEventId() {
      const firstCartItem = this.$store.state.cart.cartEvents[0];
      return firstCartItem ? firstCartItem.activityId : null;
    },
    addDisabled() {
      return this.cartEventId && this.cartEventId !== this.item.activityId;
    },
    getCurrencySymbol() {
      const currencySymbols = {
        PEN: 'S/',
        USD: '$',
      };
      return this.event && this.event.currency ? currencySymbols[this.event.currency] || '' : '';
    }
  },
  created() {
    // const defaultDate = this.event.dates[0];
    // this.calendarSelectedDate = defaultDate.day;
    // this.hour = defaultDate.hours[0];
  },
  methods: {
    addToCart(type) {
      this.$emit('eventSelected', this.item);
      this.$emit('addEventToCart', type, false)
    },
    dateClass(_, date, item) {
      const eventDates = item.dates.map((date) => date.day);
      const dateString = this.formatDate(date);
      // console.log("eventDates:", JSON.parse(JSON.stringify({ dateString, eventDates })), eventDates.includes(dateString));
      return eventDates.includes(dateString) ? 'table-info' : '';
    },
    dateDisabled(_, date) {
      const eventDates = this.listDates.map((date) => date.date);
      const dateString = this.formatDate(date);
      return !eventDates.includes(dateString);
    },
    orderItems(items) {
      let orderItems = [...items];
      if (items.length > 1) {
        orderItems.sort((a, b) => {
          return a.ticketTypeId - b.ticketTypeId;
        });
      }
      return orderItems;
    },
    formatHours(hour) {
      const start = hour.timeStart ? this.parseHourString(hour.timeStart) : "";
      const end = hour.timeEnd ? this.parseHourString(hour.timeEnd) : "";
      return start && end ? `${start} - ${end}` : start || end;
    },
    async getListTicketTypes(item) {
      item.types = [];
      try {
        this.$store.dispatch('changeLoadingJoinnus', true);
        item.types = await api.getListTicketTypes(this.event.activityId,item.dateHourId);
        item.types.forEach((type) => {
          const {
            soldOutGroup = false,
            stock = 0,
            saleStatus = { quantityInReserve: 0 },
            type: itemType,
            minQuantityPerOrder = 0,
            maxQuantityPerOrder = 0,
            priceStock = 0
          } = type;

          type.availableStock = soldOutGroup ? 0 : stock - saleStatus.quantityInReserve;
          type.price = priceStock;

          if (itemType === 'venue') {
            type.value = "";
          } else if(itemType === 'combo') {
            type.minQuantityCombo = 1;
            type.maxQuantityCombo = Math.floor(maxQuantityPerOrder / minQuantityPerOrder)
            type.value = type.minQuantityCombo;
            type.price = priceStock * minQuantityPerOrder;
          } else {
            type.value = (minQuantityPerOrder === 1 && maxQuantityPerOrder > 1
              && type.availableStock > 1)
              ? 2
              : minQuantityPerOrder;
          }

        });
        item.types = this.orderItems(item.types);
        this.updateEventSelected({hour:item});
      } catch (error) {
        console.error("Error fetching data:", error);
        const errorCode = getSafe(() => error.response.data.code);
        const errorMessage = getSafe(() =>  error.response.data.message);
        const errorMsg = errorCode === 'NOT_FOUND' ? "No hay entradas configuradas para boletería." : errorMessage;
        this.ticketTypeError = errorMsg || 'Tuvimos un problema, inténtalo de nuevo en unos minutos.';
      } finally {
        this.$store.dispatch('changeLoadingJoinnus', false);
      }
    },
    updateEventSelected({ date = null, hour = null }) {
      const isSame = (date && this.eventSelectedDate) && (date.id=== this.eventSelectedDate.id)
      this.$emit('updateEventSelected', {
        date: date || this.eventSelectedDate,
        hour: isSame ? this.hour : hour
      });
    },
    quantityOptions(ticketType) {
      const {
        minQuantityPerOrder = 1,
        type = '',
        maxQuantityPerOrder = 0,
        availableStock = 0,
        maxQuantityCombo = 0,
        minQuantityCombo = 0,
      } = ticketType;
      const isCombo = type === 'combo';
      const minQuantity = isCombo ? minQuantityCombo : minQuantityPerOrder;
      const maxQuantityPerOrderEnd = isCombo ? maxQuantityCombo : maxQuantityPerOrder;
      const availableStockEnd = isCombo ? Math.floor(availableStock / minQuantityPerOrder) : availableStock;
      const maxQuantity = Math.min(maxQuantityPerOrderEnd, availableStockEnd);
      return Array.from({ length: maxQuantity - minQuantity + 1 }, (_, i) => i + minQuantity);
    },
    formatTicketLabel(quantity, ticketType) {
      const { type = ''} = ticketType;
      const isCombo = type === 'combo';
      const baseLabel = isCombo ? 'combo' : 'entrada';
      const pluralSuffix = quantity > 1 ? 's' : '';
      return `${quantity} ${baseLabel}${pluralSuffix}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.flexi {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  // padding-bottom: 0.5rem;
  width: 100%;
  @media screen and (min-width: 64em) {
    width: auto;
    flex-direction: row;
  }
}
.flexi-name {
  width: 100%;
  display: flex;
  // align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  @media screen and (min-width: 64em) {
    width: auto;
  }
}
</style>